export var hasGeneratedContentDecorations = function hasGeneratedContentDecorations(state) {
  return state.modalDecorationSet.find(undefined, undefined, function (spec) {
    return spec.key === 'generatedInlineDecoration' ||
    // TODO: AI Button experiment cleanup - platform_editor_ai_ai_button_block_elements
    spec.key === 'generatedNodeDecoration' || spec.key === 'generatedStartWidget' || spec.key === 'generatedEndWidget';
  }).length > 0;
};